import { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../../assets/logo.png";
import hamburger from "../../../assets/hamburger.png";
import Search from "../../Search/Search";
import styles from "./Header.module.scss";
import { PATHS } from "../../../routes/paths";
import userVector from "../../../assets/ownerImg.png"
import ConnectToPhantom from "../../ConnectToPhantom/ConnectToPhantom";

const Header = () => {
  const navigate = useNavigate();
  const user = localStorage.getItem("user");

  const [isOpen, setIsOpen] = useState(false);

  // handle navigation
  const handleNavigate = (path) => {
    navigate(path);
    setIsOpen(false);
  };

  // log out user
  const handleLogOut = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
    navigate("/auth/login");
  };

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <div className={styles.logoContainer} onClick={() => navigate("/")}>
          <img src={logo} alt="logo" />
        </div>
        <img src={hamburger} alt="hamburger" className={styles.hamburger} />
        <div className={styles.searchContainer}>
          <Search />
        </div>
        <nav>
          <ul>
            <li>Explore</li>
            <li>About</li>
            <li>Contact</li>
            <li onClick={() => navigate(PATHS.createCollection)}>Create</li>
          </ul>
        </nav>

        {/* <ConnectToPhantom /> */}
        {!user ? (
          <div className={styles.userContainer}>
            <span
              className={styles.shadow}
              onClick={() => setIsOpen(!isOpen)}
            />
            <img src={userVector} alt={"avatar"} />
            <p>John Snow</p>

            {isOpen && (
              <div className={styles.dropdown}>
                <ul>
                  <li onClick={() => handleNavigate(PATHS.profile)}>
                    My Profile
                  </li>
                  <li onClick={() => handleNavigate(PATHS.explore)}>
                    Collections
                  </li>
                  <li onClick={() => handleNavigate(PATHS.subscription)}>
                    Subscription
                  </li>
                  <li onClick={() => handleNavigate(PATHS.settings)}>
                    Settings
                  </li>
                  <li onClick={() => handleNavigate("/auth/login")}>Log Out</li>
                </ul>
              </div>
            )}
          </div>
        ) : (
          <div className={styles.btnContainer}>
            <button>Join Now</button>
            <button>Sign In</button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
